import { Avatar } from "primereact/avatar";

import type { UserAvatarViewModel } from "./types-user-avatar";

export function UserAvatarView({
  avatarRef,
  className,
  size,
  foto,
  iniciais,
  icone,
  ariaLabel,
}: UserAvatarViewModel) {
  return foto ? (
    <Avatar
      ref={avatarRef}
      className={className}
      size={size}
      shape="circle"
      image={foto.src}
      imageAlt={foto.alt}
      onImageError={foto.falhou}
    />
  ) : (
    <Avatar
      ref={avatarRef}
      className={className}
      size={size}
      shape="circle"
      aria-label={ariaLabel}
      label={iniciais}
      icon={icone}
    />
  );
}
